export default {"src":"/_next/static/media/Permission guide.69e3456c.gif","height":666,"width":684,"blurWidth":0,"blurHeight":0};